var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHelpIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Help Icon",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3 0C1.34315 0 0 1.34315 0 3V21C0 22.6569 1.34315 24 3 24H21C22.6569 24 24 22.6569 24 21V3C24 1.34315 22.6569 0 21 0H3ZM12.0549 18.9231C12.7996 18.9231 13.4006 18.32 13.4006 17.5769C13.4006 16.8333 12.7996 16.2308 12.0549 16.2308C11.3129 16.2308 10.7093 16.8338 10.7093 17.5769C10.7093 18.32 11.3129 18.9231 12.0549 18.9231ZM8.29594 10.3077C8.29594 7.45008 9.92801 6 12.0975 6C14.2222 6 15.7289 7.31115 15.7036 9.44508C15.6847 10.9102 14.7936 11.8719 14.0769 12.6452C13.0767 13.7235 13.081 14.2908 13.0864 14.9949C13.0868 15.047 13.0872 15.0999 13.0872 15.1538H10.964C10.964 15.0944 10.9639 15.0362 10.9639 14.9792C10.9619 13.4104 10.9611 12.7235 12.4803 11.2791L12.4826 11.2769C13.0873 10.7012 13.5652 10.2462 13.4991 9.35031C13.4377 8.49792 12.7253 8.05208 12.0539 8.05208C10.9134 8.05208 10.4256 9.06708 10.4256 10.3077H8.29594Z",
    fill: "#DAD2C1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHelpIcon);
export default __webpack_public_path__ + "static/media/Help-Icon.43a531c439e671004b84f8c27aeebf2d.svg";
export { ForwardRef as ReactComponent };